export default __webpack_public_path__ + "static/media/california.dd9b480c.svg";